var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoubleChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.28033 5.53033C7.57322 5.23744 7.57322 4.76256 7.28033 4.46967C6.98744 4.17678 6.51256 4.17678 6.21967 4.46967L3.21967 7.46967C2.92678 7.76256 2.92678 8.23744 3.21967 8.53033L6.21967 11.5303C6.51256 11.8232 6.98744 11.8232 7.28033 11.5303C7.57322 11.2374 7.57322 10.7626 7.28033 10.4697L4.81066 8L7.28033 5.53033Z",
    fill: "#465169"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2803 5.53033C12.5732 5.23744 12.5732 4.76256 12.2803 4.46967C11.9874 4.17678 11.5126 4.17678 11.2197 4.46967L8.21967 7.46967C7.92678 7.76256 7.92678 8.23744 8.21967 8.53033L11.2197 11.5303C11.5126 11.8232 11.9874 11.8232 12.2803 11.5303C12.5732 11.2374 12.5732 10.7626 12.2803 10.4697L9.81066 8L12.2803 5.53033Z",
    fill: "#465169"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevron);
export default __webpack_public_path__ + "static/media/doubleChevron.62c556d360e04aa802b322b4b1fa378e.svg";
export { ForwardRef as ReactComponent };